import { KaffaLogo } from "./KaffaLogo";
import { useLocale } from "@/contexts/LocaleContext";

export const Footer = () => {
  const { t } = useLocale();
  return (
    <footer className="border-t border-border bg-background mt-20">
      <div className="mx-auto max-w-[1600px] px-4 sm:px-8 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <KaffaLogo />
          <p className="text-sm text-muted-foreground mt-4 max-w-md leading-relaxed">
            {t("footer.subtitle")}
          </p>
        </div>
        <div>
          <div className="font-mono-data text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">
            {t("footer.platform")}
          </div>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-accent transition-colors">{t("nav.home")}</a></li>
            <li><a href="/marketplace" className="hover:text-accent transition-colors">{t("nav.marketplace")}</a></li>
            <li><a href="/tours" className="hover:text-accent transition-colors">{t("nav.tours")}</a></li>
            <li><a href="/register" className="hover:text-accent transition-colors">{t("hero.cta_register")}</a></li>
            <li><a href="/login" className="hover:text-accent transition-colors">{t("nav.login")}</a></li>
          </ul>
        </div>
        <div>
          <div className="font-mono-data text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">
            {t("footer.contact")}
          </div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>trade@kaffaexchange.com</li>
            <li>+55 11 4444-2200</li>
            <li>{t("footer.location")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="mx-auto max-w-[1600px] px-4 sm:px-8 py-4 flex items-center justify-between text-xs text-muted-foreground font-mono-data uppercase tracking-wider">
          <span>{t("footer.copyright")}</span>
          <span>{t("footer.version")}</span>
        </div>
      </div>
    </footer>
  );
};
